export const FEMALE_TEST_RESULT = {
  resultA: {
    character: "《钗釧记·相约讨钗》之芸香",
    image: require("@/assets/imgs/result/female_resultA.png"),
    profession: "贴旦",
    poem: "喏喏喏，我告座啦！",
    characteristic:
      "你是天真无虑的快乐小狗，直性子热肠子，容易让看到你的每个人都心生喜欢。只是有时候过于单纯，容易迷路罢了啦！不过这也没有什么不好，毕竟大家都乐意帮你的哟！",
    synopsis:
      "史碧桃因父嫌贫爱富、欲图赖婚，暗中派侍女芸香去至未婚夫皇甫吟家，约在中秋之夜到后花园赠其钗钏银两，以便迎娶。适逢皇甫吟不在家中，芸香就对他母亲李氏说了。皇甫吟得知后正在犹豫之际，被他的同学韩时忠约去讲书，在讲书中透露真情，不料韩时忠冒名潜入后花园，骗取了钱财物品。后来史女不见皇甫吟来迎娶，又叫芸香去询问究竟，与吟母争吵一场。《相约讨钗》两部分往往连演，其中小女孩芸香与老太太李氏之间的互动，非常可爱生动，一定要去看看呀！",
    bgm: require("@/assets/bgms/female_resultA.mp3"),
    videoPerformer: "苏州昆剧团表演艺术家沈国芳（饰芸香）与陈玲玲（饰李氏）",
    videoTitle: "昆曲《钗钏记·相约讨钗》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV19x411V7i7",
  },
  resultB: {
    character: "《西厢记·跳墙着棋》之红娘",
    image: require("@/assets/imgs/result/female_resultB.png"),
    profession: "贴旦",
    poem: "你看日落窗纱，两下含情对月华",
    characteristic:
      "你是很有些主见谋略的人儿，在乖巧聪明之外，更多了几分古灵精怪，爱吃瓜爱嗑CP，自己可以单身，CP一定要在一起！行动力超强的你，不管做什么事都会成功的！",
    synopsis:
      "崔莺莺派遣红娘传书，约张生在夜间跳墙入院相会，怕别人知道后有损名节，所以瞒着红娘。红娘早就看出了实情，于是待引张生跳入院墙后，红娘故意揣着明白装糊涂，戏弄了莺莺和张生一番。《跳墙着棋》一出中，红娘一边和小姐下棋、一边和张生打手势暗号，一会掩护张生进来，一会假装审判张生，真是作为闺蜜吃瓜要吃两头，当爱情军师忙得不得了哈哈哈。",
    bgm: require("@/assets/bgms/female_resultB.mp3"),
    videoPerformer:
      "浙江昆剧团表演艺术家唐蕴岚（饰红娘）、杨崑（饰崔莺莺）与李公律（饰张生）",
    videoTitle: "昆曲《西厢记·跳墙着棋》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1GK4y1j7SE",
  },
  resultC: {
    character: "《牡丹亭·惊梦》之杜丽娘",
    image: require("@/assets/imgs/result/female_resultC.png"),
    profession: "闺门旦",
    poem: "可知我一生儿爱好是天然",
    characteristic:
      "你是浪漫主义与理想主义的综合体，充满着对美好事物的向往与追求，因此对待亲情友情爱情都非常真诚。具备丰富的想象力和创造力，虽然有时会导致对细节过于敏感哦～",
    synopsis:
      "杜丽娘后花园赏春，但良辰美景反引起她自顾凄凉。回房后丽娘自叹年已十六，却无知心人，困倦入梦。梦中花神引一书生持柳枝上，书生请丽娘题诗，两人在花神庇护下缱绻缠绵，但梦醒后却无处追寻，十分惆怅。",
    bgm: require("@/assets/bgms/female_resultC.mp3"),
    videoPerformer:
      "上海昆剧团表演艺术家华文漪（饰杜丽娘）、岳美缇（饰柳梦梅）",
    videoTitle: "昆曲《牡丹亭·惊梦》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV17M4m1o7uv",
  },
  resultD: {
    character: "《艳云亭·痴诉点香》之萧惜芬",
    image: require("@/assets/imgs/result/female_resultD.png"),
    profession: "贴旦",
    poem: "小痴儿也曾惜花趁早天",
    characteristic:
      "你是善于观察与思考的体质，但有时容易内耗，给自己太多压力。不过你也绝不缺乏直面挑战与去冒险的勇气！如果真的下定决心要做什么事，无论遇到什么困难，你都会以积极的态度去面对！",
    synopsis:
      "萧惜芬为避祸装疯诈痴，前去寻找知晓爱人洪绘下落的算命先生诸葛暗诉情求救，但诸葛暗误以为她是真正的疯子，自认晦气，收拾卜卦，折返庙中，更深人静，萧惜芬追到诸葛庙中，向诸葛暗倾诉家中受害经过，请求诸葛暗为其卜上一卦，诸葛暗算出惜芬灾期已满，诸葛暗怜之，许诺助其寻访洪绘。剧中二人一唱一白，一哀一乐，呼应地恰到好处，文词情感十分打动人。",
    bgm: require("@/assets/bgms/female_resultD.mp3"),
    videoPerformer:
      "上海昆剧团表演艺术家梁谷音（饰萧惜芬）、江苏省昆剧院表演艺术家姚继荪（饰诸葛暗）",
    videoTitle: "昆曲《艳云亭·痴诉点香》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1BW411G7TQ",
  },
  resultE: {
    character: "《铁冠图·刺虎》之费贞娥",
    image: require("@/assets/imgs/result/female_resultE.png"),
    profession: "正旦",
    poem: "方显的大明朝有个女佳人",
    characteristic:
      "你是脚踏实地 、客观冷静 、超绝独立能干的事业女性，男人只会影响你拔刀的速度。重情重义又事业心超强，在人群中你往往是最可靠的那一个！不过作为拼命三娘也要记得爱惜自己呀～",
    synopsis:
      "亡明宫女费贞娥假扮明朝公主，意图行刺李自成，不想李自成将其赐给虎将李固为妻。新婚之夜，费贞娥把李固灌醉后借机刺死，然后自杀身亡。剧中费贞娥一边暗自垂泪，一边假装欢喜，与李固周旋，呈现颇见演员功力。最后她脫去凤冠霞帔，以弱女之姿刺杀李固，悲壮决绝，动人心魄！",
    bgm: require("@/assets/bgms/female_resultE.mp3"),
    videoPerformer: "北方昆曲剧院表演艺术家洪雪飞（饰费贞娥）周万江（饰李固）",
    videoTitle: "昆曲《铁冠图·刺虎》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1DB4y1p7Ty",
  },
  resultF: {
    character: "《雷峰塔·断桥》之白素贞",
    image: require("@/assets/imgs/result/female_resultF.png"),
    profession: "闺门旦",
    poem: "不记得当时，曾结三生证",
    characteristic:
      "你有丰富的内心世界，特别会为人考虑，照顾比自己弱小的人～心中想被人爱，又怕被人爱。为了别人愿意牺牲自己，所以往往逞强。容易原谅伤害过自己的人，善于共情以至于太过心软，要小心变成恋爱脑哦～",
    synopsis:
      "白素贞和小青水漫金山，大战法海，战败后行至西湖断桥，白素贞正腹痛难忍，面临生产。许仙此刻从金山寺逃出，在断桥与白素贞相遇。小青痛恨许仙负心，拔出龙泉宝剑欲杀掉许仙，许仙深表忏悔之意，白素贞念夫妻之情，亦为之求情，小青作罢，三人言归于好。",
    bgm: require("@/assets/bgms/female_resultF.mp3"),
    videoPerformer:
      "表演艺术家梅兰芳（饰白素贞）、俞振飞（饰许仙）与梅葆玖（饰小青）",
    videoTitle: "昆曲《白蛇传·断桥》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1Si4y1G7vt",
  },
};

export const MALE_TEST_RESULT = {
  resultA: {
    character: "《长生殿·闻铃》之唐明皇",
    image: require("@/assets/imgs/result/male_resultA.png"),
    profession: "大官生",
    poem: "看云山重叠处，似我乱愁交并",
    characteristic:
      "你能力出众、有权有势，善于谋略思考，杀伐果决，是传统意义上的霸道总裁。却也因此容易专断固执，耽于逸乐，要时刻警惕不可松懈哦！尤其是感情上，千万要注意拿捏好分寸呱！",
    synopsis:
      "唐明皇因安史之乱西行幸蜀，逃亡过程中路过栈道，登临剑阁，时值风雨大作，雨铃夹杂，让唐明皇勾起对在马嵬死去的杨贵妃的思念，悲从中来。这一出戏是大官生经典的唱功戏，其中武陵花一支曲子高亢凄怆，极考验唱功。",
    bgm: require("@/assets/bgms/male_resultA.mp3"),
    videoPerformer: "上海昆剧团表演艺术家蔡正仁",
    videoTitle: "昆曲《长生殿·闻铃》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1Gx411D7WA",
  },
  resultB: {
    character: "《白罗衫·看状》之徐继祖",
    image: require("@/assets/imgs/result/male_resultB.png"),
    profession: "小官生",
    poem: "须知道察奸伸枉是乌台",
    characteristic:
      "你是有强大的逻辑思维，擅长领导和管理，重视规则和程序。事业心超强的你，擅长拿出实际行动而不内耗，你的责任感也会为身边的人带去安全感。不过有时候处理人际关系的时候，会有点太一板一眼，而显得有点过于冷漠不近人情哦~",
    synopsis:
      "徐继祖春闱高中，升任八府巡按，巡视江南一地，恰遇生父苏云来衙告状。继祖见所告是与自己父亲同名的徐能，顿起疑心。于是便讯问知道自己身世的奶公，才知原委底细，原来杀人凶手就是养父徐能，天理昭彰，真相大白。剧中年轻的徐继祖初为官吏，在天理人情亲仇之间两难的踌躇与内心冲突，让人动容。",
    bgm: require("@/assets/bgms/male_resultB.mp3"),
    videoPerformer: "昆剧表演艺术家俞振飞（饰徐继祖）与包传铎（饰奶公）",
    videoTitle: "昆曲《白罗衫·看状》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1uJ411V7gc",
  },
  resultC: {
    character: "《宝剑记·夜奔》之林冲",
    image: require("@/assets/imgs/result/male_resultC.png"),
    profession: "武生",
    poem: "此一去博得个斗转天回，管教你海沸山摇",
    characteristic:
      "你简单纯粹，有很高的自我修养，各方面条件都非常优秀。性格温良，不愿意与人起尖锐冲突，会选择忍让，但特别痛恨别人的背叛，也容易因为现实和期望之间的差距而感到挫败。不过，请一定要继续向前啊！",
    synopsis:
      "东京八十万禁军教头林冲，因为朝政腐败表谏诤童贯、高俅，因而和高俅结仇；高俅之子又看上了林冲的妻子张氏，图谋霸占，于是父子二人设计陷害林冲。林冲受到高俅冤屈迫害后，走投无路只得亡命水泊梁山。途中想起自己被人迫害，母妻遭人欺凌，立志上梁山报仇。该剧既讲究唱工又讲究做工，身段极其繁复，并且整出戏都是边舞边唱，对演员要求很高，有“男怕夜奔”之说。",
    bgm: require("@/assets/bgms/male_resultC.mp3"),
    videoPerformer: "河北梆子剧团表演艺术家裴艳玲",
    videoTitle: "昆曲《宝剑记·夜奔》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1wE411X73X",
  },
  resultD: {
    character: "《红梨记·亭会》之赵汝州",
    image: require("@/assets/imgs/result/male_resultD.png"),
    profession: "巾生",
    poem: "今宵酒醒倍凄清，早月印窗棂",
    characteristic:
      "你是人生体验派，在需要和人打交道的场合中往往是最亮眼的那个。诙谐健谈有才情又是究极颜控的你，小心变成养鱼的海王哈！因为常为太多的事情分心，很容易被长辈说不顾前程的样子呢。最后，喝酒贪杯会误事，谨记，谨记！",
    synopsis:
      "刘太守为了治赵汝舟贪恋美色、不顾前程的毛病，让名妓谢素秋假扮王同知的女儿夜会赵汝舟，之后再骗他王小姐是个女鬼。但赵、谢二人虽未见过面，暗地里却相慕已久。在春夜花园中相会，互诉爱慕之情后，谢素秋以王小姐的身份与赵汝舟约定次日书斋再相会。",
    bgm: require("@/assets/bgms/male_resultD.mp3"),
    videoPerformer:
      "浙江昆剧团表演艺术家汪世瑜与上海昆剧团昆剧表演艺术家张洵澎",
    videoTitle: "昆曲《红梨记·亭会》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1UM4y1K71m",
  },
  resultE: {
    character: "《占花魁·湖楼》之秦钟",
    image: require("@/assets/imgs/result/male_resultE.png"),
    profession: "介于巾生穷生之间",
    poem: "情向前生种，人逢今世缘",
    characteristic:
      "你是善良热心的快乐大狗，特别善于帮助别人！真正的至诚君子，具有将理想化为现实的能力，纵然早就看透了世界与生活的本质，但依然热爱生活。认真善良勤奋的你，最终一定会得到命运的善待。",
    synopsis:
      "卖油郎秦钟某日行经西湖, 偶遇一绝色美人, 惊叹且思慕不已。次日便暂停生意, 前往西湖边盘旋,盼再见佳人却苦候不得, 上湖畔酒楼独酌, 从酒保口中探知佳人乃临安第一名妓， 惋惜佳人身处风尘之余, 难抑想望之情, 决心积蓄一年，攒十两银子来与美人相见。",
    bgm: require("@/assets/bgms/male_resultE.mp3"),
    videoPerformer: "上海昆剧团表演艺术家岳美缇（饰秦钟）与张铭荣（饰时阿大）",
    videoTitle: "昆曲《占花魁·湖楼》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1hK411F7Cy",
  },
  resultF: {
    character: "《玉簪记·琴挑》之潘必正",
    image: require("@/assets/imgs/result/male_resultF.png"),
    profession: "巾生",
    poem: "月明云淡露华浓，欹枕愁听四壁蛩",
    characteristic:
      "你天性浪漫，具有自给自足的精神世界，艺术天赋和表达能力都很出众，有良好的人缘！善于捕捉身边人的情感变化，但自身也因此比较容易受到负面情绪干扰，影响自己的状态。不要让自己背负太多世俗压力会比较快乐喔！",
    synopsis:
      "北宋末年，书生潘必正赴京赶考未中，转而到姑母所在的女贞观中继续攻读，以备来年再考。一天晚上，他在观中散步时，遇到美丽的尼姑陈妙常正在弹琴。两人交谈甚欢，潘必正被陈妙常的美貌和才华所吸引，开始借琴抒发对陈妙常的爱慕之情。陈妙常虽然也对潘必正心生爱慕，但因戒律所限，她故作生气以掩饰内心的情感。但最终两人通过琴声和对话，逐渐加深了对彼此的了解和感情，是昆曲中最基础的生旦对手戏之一。",
    bgm: require("@/assets/bgms/male_resultF.mp3"),
    videoPerformer:
      "浙江昆剧团表演艺术家汪世瑜（饰潘必正）与王奉梅（饰陈妙常）",
    videoTitle: "昆曲《玉簪记·琴挑》",
    videoUrl: "//player.bilibili.com/player.html?bvid=BV1W4411u72c",
  },
};
